var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeterNodeInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Meter_Node") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid-Editor_st2",
    transform: "translate(-579.000000, -424.000000)",
    fill: "#6b6b6b",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(447.000000, 229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Dashboard-Meter_1489185",
    transform: "translate(132.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,0.126069767 C5.90139535,0.126069767 0.125767442,5.90139535 0.125767442,13 C0.125767442,20.0986047 5.90139535,25.8739302 13,25.8739302 C20.0986047,25.8739302 25.8742326,20.0986047 25.8742326,13 C25.8742326,5.90139535 20.0986047,0.126069767 13,0.126069767 Z M23.3836744,14.2093023 C23.2866279,15.0473488 23.0919302,15.8560698 22.8080465,16.6221628 L16.562907,16.6221628 C16.3963256,16.1326977 16.1314884,15.6897907 15.7922791,15.314 L19.3993256,11.518907 L17.6461395,9.8527907 L13.5934651,14.117093 C13.3993721,14.0862558 13.2022558,14.0656977 13,14.0656977 C11.3468837,14.0656977 9.9425814,15.1377442 9.43709302,16.6221628 L3.19225581,16.6221628 C2.90837209,15.8560698 2.71367442,15.0473488 2.61662791,14.2093023 L4.43934884,14.2093023 L4.43934884,11.7906977 L2.61662791,11.7906977 C2.8457907,9.8125814 3.62911628,8.00195349 4.80667442,6.51632558 L6.24725581,7.95690698 L7.9572093,6.24695349 L6.51693023,4.80667442 C8.00225581,3.62881395 9.8125814,2.84609302 11.7906977,2.61693023 L11.7906977,4.43904651 L14.2093023,4.43904651 L14.2093023,2.61693023 C16.1874186,2.8457907 17.9977442,3.62881395 19.4830698,4.80667442 L18.0427907,6.24695349 L19.7527442,7.95690698 L21.1933256,6.51632558 C22.371186,8.00195349 23.1542093,9.81227907 23.3833721,11.7906977 L21.5606512,11.7906977 L21.5606512,14.2093023 L23.3836744,14.2093023 Z M14.3471628,17.8314651 C14.3471628,18.5745814 13.742814,19.1789302 13,19.1789302 C12.257186,19.1789302 11.6528372,18.5745814 11.6528372,17.8314651 C11.6528372,17.0886512 12.257186,16.4843023 13,16.4843023 C13.742814,16.4843023 14.3471628,17.0886512 14.3471628,17.8314651 Z",
    id: "Meter_Node"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeterNodeInfoIcon);
export default __webpack_public_path__ + "static/media/Meter_Node_info_icon.9eea5e14ac16e0cdd47dfe021ea677d0.svg";
export { ForwardRef as ReactComponent };